import type { APIStepsTabs } from '@/scopes/checkout/infrastructure/api/types';
import type { StepsTabs } from '../../domain/types';

export interface BookingStepsResponseMapper {
  map: (data: APIStepsTabs) => StepsTabs;
}

export const createBookingStepsResponseMapper = () => {
  function map(data: APIStepsTabs): StepsTabs {
    if (data.bookingStepsTabs && data.bookingStepsTabs.length === 0) {
      return { steps: {} };
    }
    const activeStepIndex = data.bookingStepsTabs.findIndex((step) => step.active);
    return {
      steps: {
        activeStep: data.bookingStepsTabs.find((step) => step.active)?.text ?? '',
        items: data.bookingStepsTabs.map(({ text, disabled, linkUrl }, index) => ({
          text,
          disabled,
          completed: index < activeStepIndex,
          url: linkUrl ?? '',
        })),
      },
    };
  }

  return { map };
};
